
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import {pathConstants} from "../../../shared/pathConstants";

export const accountService = {
    resetPassword,
    checkTokenFirst,
    logout,
    openForgetPasswordModal,
    hideForgetPasswordModal
};

function resetPassword(token, newPassword, confirmPassword) {
    return axios.post(pathConstants.API + '/accounts/reset-password?token='+token,
        { newPassword: newPassword, confirmPassword: confirmPassword },
        {headers: {publicService: true}}
        ).then(() => {
            return true
        })
        .catch(() => {
            return false;
        });
}

function checkTokenFirst(token) {
    return axios
        .post(pathConstants.API + '/accounts/check-mail-token', token, {
            headers: {
                'content-type': 'text/plain',
                publicService: true
            },
        })
        .then(res => {
            return res.data;
        }, err => {
            return Promise.reject(err.response.data.detail);
        });
}

function logout() {
    return axios.get(pathConstants.API + '/users/logout').then(() => {
        return true;
    }).catch(error => {
        return false;
    });
}

function openForgetPasswordModal(instance) {
    instance.$emit('bv::show::modal', 'forget-password');
}

function hideForgetPasswordModal(instance) {
    instance.$emit('bv::hide::modal', 'forget-password');
}
